<template>
  <div class="articleDetail">
    <div class="crumbs">
      <div class="container">
        <div>
          <router-link :to="navData.path" class="link">
            {{ navData.text }}
          </router-link>
          > 报名详情
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="container">
        <div class="article">
          <div>
            <div class="detail">
              <div class="detailContent">
                <el-row :gutter="20">
                  <el-form size="medium" label-width="120px" label-position="right">
                    <el-col :span="24">
                      <div class="pre_info_title">
                        <div class="gr_list_p"></div>
                        <div class="gr_list_c">项目信息</div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="项目名称">
                        :
                        <span class="content">{{signUpDetailForm.projectName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="项目编号">
                        :
                        <span class="content">{{signUpDetailForm.projectNumber}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="项目类型">
                        :
                        <span class="content">{{signUpDetailForm.projectType}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="项目所在地">
                        :
                        <span class="content">{{signUpDetailForm.address}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="招标人名称">
                        :
                        <span class="content">{{signUpDetailForm.tenderName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="招标内容">
<!--                      :  <span class="content">{{signUpDetailForm.content}}</span>-->
                        <div v-html="signUpDetailForm.content" class="ql-editor"></div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="备注">
                        :
                        <span class="content">{{signUpDetailForm.remark}}</span>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
                <el-row :gutter="20">
                  <el-form size="medium" label-width="120px" label-position="right">
                    <el-col :span="24">
                      <div class="pre_info_title">
                        <div class="gr_list_p"></div>
                        <div class="gr_list_c">报名信息</div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="报名时间">
                        :
                        <span class="content">{{signUpDetailForm.createTime}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="资质文件">
                        :
                        <a
                          :href="'https://minio.akbigdata.cn/' + signUpDetailForm.tenderDocument"
                          :download="signUpDetailForm.tenderDocumentName"
                        >{{signUpDetailForm.tenderDocumentName}}</a>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="审核状态">
                        :
                        <span class="content">{{1 == signUpDetailForm.status ? '审核中' : 2 == signUpDetailForm.status ? '审核通过' :'审核未通过'}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="原因说明" v-if="3 == signUpDetailForm.status">
                        :
                        <span class="content">{{signUpDetailForm.signUpRemark}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" style="text-align: center; margin-top: 60px">
                      <el-form-item v-if="1 == signUpDetailForm.status">
                        <el-button type="primary"  @click="cancelSignUp">取消报名</el-button>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import { getMySignUpDetail, cancelSignUp } from '@/api';
    export default {
        data() {
            return {
                navData: this.utils.navMap[this.$route.params.parent],
                signUpDetailForm:{
                    projectId: "",
                    projectName: "",
                    projectNumber: "",
                    projectType: "",
                    address: "",
                    tenderName: "",
                    content: "",
                    remark: "",
                    status: "",
                    createTime: "",
                    enterpriseName: "",
                    tenderDocument: "",
                    tenderDocumentName: "",
                    negotiationDocument: "",
                    negotiationDocumentName:"",
                    price: "",
                    signUpRemark: ""
                }
            };
        },

        computed: {},
        watch: {},
        mounted() {},
        created() {
            // 获取项目详情
            console.log('@@@@' + this.$route.params.id);
            getMySignUpDetail(this.$route.params.id).then(res =>{
                if(res.data.success){
                  this.signUpDetailForm = res.data.data;
                }
            });
        },
        methods: {
            // 取消报名
            cancelSignUp() {
                console.log("cancelSignUp=============");
                var that = this;
                this.$confirm("确认取消吗？", "提示", {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(function () {
                    that.loading = true;
                    cancelSignUp(localStorage.getItem("supplierId"), that.signUpDetailForm.projectId).then(res => {
                        if (res.data.success) {
                            that.loading = false;
                            that.$message({
                                type: "success",
                                message: "操作成功"
                            });
                            that.$router.push('/my/mySignUp');
                        }
                    })
                });
            },
        }
    };
</script>
<style scoped>
  .crumbs {
    height: 50px;
    line-height: 50px;
    color: #333;
    font-size: 14px;
    border-bottom: solid 1px #d6d6d6;
    margin-bottom: 30px;
  }
  .crumbs .link {
    color: #8d8d8d;
  }
  .title {
    text-align: center;
    font-weight: 800;
    font-size: 20px;
    margin-bottom: 20px;
    line-height: 30px;
  }
  .infos {
    color: #888;
    font-size: 15px;
    border-bottom: 1px solid #eee;
    line-height: 35px;
  }
  .articleDetail {
    padding-bottom: 80px;
  }
</style>
